const CONNECTION_PORT = `${process.env.REACT_APP_SOCKET_CONNECTION_PORT}`;

export const socket = new WebSocket(CONNECTION_PORT);
